import { Box } from '@chakra-ui/react';
import { LastMessageText } from '@halo/ui-chat-react';
import { Emoji } from '@/components/Emoji';
import { MsgForwardIcon } from '../../msg-parts';
import type { MsgTextPreviewContentProps } from './msg-text-preview-content';
import { MsgTextPreviewContent } from './msg-text-preview-content';

export interface MsgTextPreviewProps extends MsgTextPreviewContentProps {}

export const MsgTextPreview = memo(function MsgTextPreview({
  message,
}: MsgTextPreviewContentProps) {
  return (
    <LastMessageText>
      <Emoji.MessagePrefix reactions={message.emoji_reaction} />
      <MsgForwardIcon message={message} />
      <Box flex="1" minW="0" truncate>
        <MsgTextPreviewContent message={message} />
      </Box>
    </LastMessageText>
  );
});
